export const ProductStatus = [
    { label: 'Active', value: 'ACTIVE' },
    { label: 'Inactive', value: 'INACTIVE' },
    { label: 'Suspended', value: 'SUSPENDED' },
    { label: 'Terminated', value: 'TERMINATED' },
] as const;

export const ProductType = [
    { label: 'Prepaid', value: 'PREPAID' },
    { label: 'Credit', value: 'CREDIT' },
] as const;
